import { schema } from 'normalizr';

import { processBroadcastForNotification } from '../strategies/broadcastForNotification';

import { groupSchema } from './group';

export const broadcastForNotificationSchema = new schema.Entity(
  'liveEventsForNotification',
  { groupId: groupSchema },
  { idAttribute: 'broadcastId', processStrategy: processBroadcastForNotification }
);
